var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00333125 9.91251C0.0932743 9.46894 0.359772 9.10226 0.639595 8.73853C2.5817 6.22497 4.52047 3.7114 6.45592 1.19784C6.70243 0.878465 6.98558 0.603452 7.39199 0.446724C8.00827 0.210153 8.70782 0.349138 9.20418 0.813408C9.33076 0.928737 9.44402 1.05885 9.54396 1.19192C11.5394 3.77646 13.5348 6.36395 15.5268 8.95144C15.7434 9.23237 15.9333 9.52217 15.9866 9.86816C16.0698 10.4182 15.7634 10.8204 15.1504 10.9386C14.9372 10.98 14.7174 10.9978 14.5008 10.9978C10.1702 11.0007 5.83964 11.0007 1.50905 10.9978C1.27253 10.9978 1.02935 10.9741 0.799494 10.9239C0.373097 10.8292 0.0999368 10.5779 9.65338e-09 10.1905C0.00333124 10.0988 0.00333125 10.0071 0.00333125 9.91251Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/arrowup.b20dd897fd9a03d7cf5f65685954ffef.svg";
export { ForwardRef as ReactComponent };